import React, {Component} from 'react'
import {connect} from 'react-redux'
import {ListItem, ListGroup} from 'components/ListGroup'
import {actionCreators} from 'actions'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'
import api from 'api'
import {toDateStr} from 'utils'
import {isEmpty, toUpper} from 'lodash'
import ReportList from 'procedureStatuses/ReportList'
import Modal from 'jbc-front/components/Modal'
import withRouterLegacy from 'withRouterLegacy'
import styles from 'procedureStatuses/Show.scss'
import Prepare from 'procedureStatuses/eGov/Prepare'
import RelatedRecordsAlertPdf from 'procedureStatuses/RelatedRecordsAlertPdf'
import RelatedRecordsAlertTodo from 'procedureStatuses/RelatedRecordsAlertTodo'
import * as StandardTodo from './todo/standard'
import * as MaternityLeaveTodo from './todo/maternityLeave'

const dateNameMap = {
  enroll: '入社予定日',
  resign: '退社予定日',
  add_dependents: '被扶養者異動日',
  remove_dependents: '被扶養者異動日',
  change_remuneration: '',
  change_address: '引越の日',
  change_name: '氏名変更日',
  start_maternity: '出産予定日',
  extend_maternity: '出産予定日',
  finish_maternity: '出産予定日',
  change_office: '転勤年月日',
  start_childcare: '育休開始日',
  extend_childcare: '育休開始日',
  finish_childcare: '育休開始日',
  additional_childcare_leave_allowance: '育休開始日',
  parental_leave: '育休開始日',
  parental_leave_support_allowance: '育休開始日',
  health_insurance_qualification_confirmation: '',
}

export const titleMap = {
  enroll: '入社の手続き',
  resign: '退社の手続き',
  add_dependents: '家族情報変更の手続き',
  remove_dependents: '家族情報変更の手続き',
  change_remuneration: '',
  change_address: '住所変更の手続き',
  change_name: '氏名変更の手続き',
  start_maternity: '産休開始の手続き',
  extend_maternity: '産休変更の手続き',
  finish_maternity: '産休終了の手続き',
  change_office: '転勤の手続き',
  start_childcare: '育休開始の手続き',
  extend_childcare: '育休延長の手続き',
  finish_childcare: '育休終了の手続き',
  additional_childcare_leave_allowance: '2回目以降の育児休業給付の手続き',
  parental_leave: '出生時育休の手続き',
  parental_leave_support_allowance: '出生後休業支援給付金の手続き',
  health_insurance_qualification_confirmation: '資格確認書交付の手続き',
}

class Show extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDeleteModal: false,
    }
  }

  handleTodoChange = (todoListNo, todoNo, todo) => {
    this.props.updateTodo(this.props.token, todoListNo, todoNo, todo.id, todo.status == 'todo' ? 'done' : 'todo')
  }

  handleTodoChangeAll = (status) => {
    const {updateTodoAll, procedureStatus} = this.props
    updateTodoAll(this.props.token, procedureStatus.id, status)
  }

  handleDelete = () => {
    const {procedureStatus, deleteProcedureStatus, token, history} = this.props
    deleteProcedureStatus(token, procedureStatus.id, history)
  }

  handleEditClick = ({num, dependentId}) => {
    const {
      match: {
        params: {id},
      },
    } = this.props
    let editUrl = `/procedure_statuses/${id}/report_edit`
    if (dependentId) {
      editUrl += `?dependent_id=${dependentId}`
    }
    editUrl += `#${toUpper(num)}`
    this.props.history.push(editUrl)
  }

  hideDeleteModal = () => {
    this.setState({showDeleteModal: false})
  }

  menuItemsEmptyTodo = [
    {
      onClick: () => {
        this.setState({showDeleteModal: true})
      },
      label: '削除する',
    },
  ]

  menuItems = [
    {
      onClick: () => {
        this.handleTodoChangeAll('done')
      },
      label: '全て完了にする',
    },
    {
      onClick: () => {
        this.handleTodoChangeAll('todo')
      },
      label: '全て対応中に戻す',
    },
    ...this.menuItemsEmptyTodo,
  ]

  getTodoModule = () => {
    const {procedureStatus} = this.props
    switch (procedureStatus.procedure_type) {
      case 'start_maternity':
      case 'extend_maternity':
      case 'finish_maternity':
        return MaternityLeaveTodo
      default:
        return StandardTodo
    }
  }

  render() {
    const {
      procedureStatus,
      history,
      match: {
        params: {id},
      },
      loadData,
    } = this.props
    if (isEmpty(procedureStatus)) {
      history.push(`/procedure_statuses/`)
      return null
    }
    const {display_last_name, display_first_name} = procedureStatus.employee
    const title = `${display_last_name} ${display_first_name}さんの${titleMap[procedureStatus.procedure_type]}`
    const hasTodoList = procedureStatus.todo_lists && procedureStatus.todo_lists.some((list) => !isEmpty(list.todos))
    const Todo = this.getTodoModule()
    const dateOn = procedureStatus.date_on && toDateStr(procedureStatus.date_on)

    return (
      <div>
        <div className={styles.headWrap}>
          <h1 className="m-title-main">{title}</h1>
          {dateNameMap[procedureStatus.procedure_type] && dateOn && (
            <div className={styles.subTitle}>
              {dateNameMap[procedureStatus.procedure_type]}: {dateOn}
            </div>
          )}
          <div className={styles.statusWrap}>
            <Todo.Progress procedureStatus={procedureStatus} />
          </div>
        </div>

        <div className="l-flex">
          <div className="l-flex4-sub">
            <RelatedRecordsAlertPdf loadProcedureStatus={loadData} />
            <Prepare />
            <ReportList procedureStatusId={id} title={title} />
          </div>

          <div className="l-flex4-main">
            <div className={styles.todoHead}>
              <p className={styles.todoTitle}>ToDoリスト</p>
              <div>
                <RelatedRecordsAlertTodo loadProcedureStatus={loadData} />
              </div>
              <Todo.Menu
                menuItems={hasTodoList ? this.menuItems : this.menuItemsEmptyTodo}
                menuItemsEmptyTodo={this.menuItemsEmptyTodo}
              />
            </div>

            {hasTodoList ? (
              <Todo.TodoList procedureStatus={procedureStatus} onTodoChange={this.handleTodoChange} />
            ) : (
              <ListGroup>
                <ListItem>ToDoリストがありません</ListItem>
              </ListGroup>
            )}
            <Modal
              header="削除の確認"
              body={`「${display_last_name} ${display_first_name}さんの${
                titleMap[procedureStatus.procedure_type]
              }」を削除しますか`}
              onSubmit={this.handleDelete}
              isOpen={this.state.showDeleteModal}
              hideModal={this.hideDeleteModal}
              submit="はい"
              cancel="いいえ"
            />
          </div>
        </div>
      </div>
    )
  }
}

class Loader extends Component {
  loadData = () => {
    const {id} = this.props.match.params
    const {token, loadData} = this.props
    loadData(id, token)
  }

  state = {
    loading: true,
  }

  componentDidMount() {
    this.loadData()
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  componentDidUpdate(prevProps) {
    if (!this.props.loading && prevProps.loading) {
      const {procedureStatus, history} = this.props
      switch (procedureStatus.status) {
        case 'draft':
          history.replace(`/${procedureStatus.procedure_type}/flow/${this.props.match.params.id}`)
          return
        case 'applying':
          history.replace(`/${procedureStatus.procedure_type}/confirm/${this.props.match.params.id}`)
          return
        default:
          break
      }
      this.setState({loading: false})
    }
  }

  render() {
    return (!this.state.loading && <Show {...this.props} loadData={this.loadData} />) || null
  }
}

const mapStateToProps = (state) => ({
  procedureStatus: state.procedureStatuses.current.data,
  loading: state.procedureStatuses.current.loading || !state.session.currentUser,
  currentUser: state.session.currentUser,
  token: state.auth.token,
})

export default withRouterLegacy(
  connect(mapStateToProps, (dispatch) => {
    return {
      loadData(id, token) {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api
              .createWithAuth(token)
              .procedureStatuses.get(
                id,
                [
                  'todo_lists',
                  'todos',
                  'employee',
                  'employee_dependents',
                  'procedure_related_records',
                  'procedure_add_dependents_data',
                  'procedure_remove_dependents_data',
                  'procedure_change_name_datum',
                  'resign_employee_input_datum',
                  'procedure_maternity_datum',
                  'procedure_childcare_datum',
                  'health_insurance',
                  'welfare_pension_insurance',
                  'employment_insurance',
                  'employee_tax_classification',
                  'egov_informations',
                  'egov_procedure_statuses',
                  'egov_client_information_completed',
                  'user',
                  'office',
                  'exist_r46_param_set',
                  'exist_r59_param_set',
                  'r47_param_set',
                  'r140_param_set',
                ],
                {employee_dependent_removed: [0, 1]}
              )
          )
        )
      },
      destroy() {
        dispatch(actionCreators.procedureStatuses.current.destroy())
      },
      async updateTodo(token, todoListNo, todoNo, todoId, status) {
        try {
          dispatch(actionCreators.procedureStatuses.updateTodo({todoListNo, todoNo, status}))
          await api.createWithAuth(token).todos.update(todoId, status)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
      async updateTodoAll(token, procedureStatusId, status) {
        try {
          dispatch(actionCreators.procedureStatuses.updateTodoAll({status}))
          await api.createWithAuth(token).procedureStatuses.updateTodoAll(procedureStatusId, status)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
      async deleteProcedureStatus(token, procedureStatusId, history) {
        try {
          await api.createWithAuth(token).procedureStatuses.delete(procedureStatusId)
          history.push(`/procedure_statuses`)
          dispatch(notifySuccess('削除しました'))
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    }
  })(Loader)
)
